mutation ApprovalSetupUrgentUpdate($input: ApprovalSetupUrgentUpdateInput!) {
  approvalSetupUrgentUpdate(input: $input) {
    clientMutationId
         _newUrgentLevel
  }
}
